export function mmToPixels(mm: number, dpi = 300) {
	return Math.round((mm * dpi) / 25.4);
}

export function pixelsToMM(pixels: number, dpi = 300) {
	return Math.round((pixels * 25.4) / dpi);
}

export function mmToPoints(mm: number) {
	//Rounded to 2 decimal places
	return Math.ceil(mm * 2.83465 * 100) / 100;
}
